import { render, staticRenderFns } from "./Dealership.vue?vue&type=template&id=afee0932&"
import script from "./Dealership.vue?vue&type=script&lang=js&"
export * from "./Dealership.vue?vue&type=script&lang=js&"
import style0 from "./Dealership.vue?vue&type=style&index=0&id=afee0932&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports